import { MapPin, AlertTriangle, Users, Share2, Heart } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost2BentoV2 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;
  
  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Main content - centered for safe zone, matching Post1 layout */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "60px 80px",
        }}
      >
        {/* Header - left aligned */}
        <div style={{ textAlign: "left", marginBottom: "28px", width: "100%", maxWidth: "800px" }}>
          <p
            style={{
              fontSize: "28px",
              fontWeight: 600,
              color: "#4E8A6E",
              margin: "0 0 8px 0",
              letterSpacing: "3px",
              textTransform: "uppercase",
            }}
          >
            Wszystko w jednym miejscu
          </p>
          <h1
            style={{
              fontSize: "56px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: "0",
              lineHeight: 1.1,
            }}
          >
            6 powodów,<br />by sprawdzić 👇
          </h1>
        </div>

        {/* Bento Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "1fr 1fr 1fr",
            gap: "12px",
            width: "100%",
            maxWidth: "800px",
          }}
        >
          {/* Large card - spans 2 rows - Main green */}
          <div
            style={{
              background: "linear-gradient(135deg, #4E8A6E 0%, #3D7A5E 100%)",
              borderRadius: "18px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gridRow: "span 2",
              boxShadow: "0 12px 40px rgba(78, 138, 110, 0.3)",
            }}
          >
            <MapPin style={{ width: "44px", height: "44px", color: "#FFFFFF" }} />
            <div>
              <h3 style={{ fontSize: "36px", fontWeight: 800, color: "#FFFFFF", margin: 0 }}>
                Mapa<br />Schronisk
              </h3>
              <p style={{ fontSize: "24px", color: "rgba(255,255,255,0.85)", margin: "4px 0 0", fontWeight: 500 }}>
                Znajdź najbliższe jednym kliknięciem
              </p>
            </div>
          </div>

          {/* Top right card - Urgent needs with orange border */}
          <div
            style={{
              background: "#FFF",
              borderRadius: "18px",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
              border: "3px solid #F97316",
            }}
          >
            <AlertTriangle style={{ width: "36px", height: "36px", color: "#F97316" }} />
            <div style={{ textAlign: "left" }}>
              <h3 style={{ fontSize: "26px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>
                Pilne potrzeby
              </h3>
              <p style={{ fontSize: "24px", color: "#6B8A7A", margin: "2px 0 0", fontWeight: 500 }}>
                Zobacz, gdzie pomoc<br />jest najpilniejsza
              </p>
            </div>
          </div>

          {/* Middle right card - Volunteering - Deep forest green */}
          <div
            style={{
              background: "linear-gradient(135deg, #3D6B56 0%, #2D5A45 100%)",
              borderRadius: "18px",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              boxShadow: "0 8px 32px rgba(45, 90, 69, 0.3)",
            }}
          >
            <Users style={{ width: "36px", height: "36px", color: "#FFFFFF" }} />
            <div style={{ textAlign: "left" }}>
              <h3 style={{ fontSize: "26px", fontWeight: 800, color: "#FFFFFF", margin: 0 }}>
                Wolontariat
              </h3>
              <p style={{ fontSize: "24px", color: "rgba(255,255,255,0.85)", margin: "2px 0 0", fontWeight: 500 }}>
                Spacery z psami<br />i pomoc na miejscu
              </p>
            </div>
          </div>

          {/* Bottom left card - Share graphics */}
          <div
            style={{
              background: "#FFF",
              borderRadius: "18px",
              padding: "16px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            }}
          >
            <div
              style={{
                width: "44px",
                height: "44px",
                background: "#E8F5EE",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Share2 style={{ width: "28px", height: "28px", color: "#4E8A6E" }} />
            </div>
            <div style={{ textAlign: "left" }}>
              <h3 style={{ fontSize: "26px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>
                Gotowe grafiki
              </h3>
              <p style={{ fontSize: "24px", color: "#6B8A7A", margin: "2px 0 0", fontWeight: 500 }}>
                Do udostępnienia<br />w social media
              </p>
            </div>
          </div>

          {/* Bottom right card - Help today - Teal green */}
          <div
            style={{
              background: "linear-gradient(135deg, #5DADA0 0%, #4D9D90 100%)",
              borderRadius: "18px",
              padding: "16px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              boxShadow: "0 8px 32px rgba(77, 157, 144, 0.3)",
            }}
          >
            <Heart style={{ width: "44px", height: "44px", color: "#FFFFFF", fill: "#FFFFFF" }} />
            <div style={{ textAlign: "left" }}>
              <h3 style={{ fontSize: "36px", fontWeight: 800, color: "#FFFFFF", margin: 0 }}>
                Pomóż dziś!
              </h3>
              <p style={{ fontSize: "24px", color: "rgba(255,255,255,0.9)", margin: "2px 0 0", fontWeight: 600 }}>
                Każdy gest się liczy 💚
              </p>
            </div>
          </div>
        </div>

      </div>
    </GraphicBackground>
  );
};

